import * as React from "react"
import PropTypes from "prop-types"

import "./layout.css"
import { Header, Footer } from "../components"

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="mx-auto mt-[98px] lg:mt-[134px]">
        <main>{children}</main>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
